import React from 'react';
import PillButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/PillButton';

export const ConsumerFinancingRedirectButton = () => {
  const handleClick = () => {
    window.location.href = '/pro/my_money/consumer_financing';
  };

  return (
    <PillButton onClick={handleClick} color="primary">
      Go to consumer financing
    </PillButton>
  );
};
